export default "/_next/static/chunks/fonts/SourceSans3-Regular-latin-eccb004236577035f5876c1c909177f0.woff2";